













































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import classInfo from '@/components/common/classInfo.vue';
import { TrainClassDto, ClassState } from '@/api/models';
@Component({ components: { classInfo } })
export default class MyTrainingIndex extends Vue {
  loading: boolean = false;
  finished: boolean = false;
  activeName: string = '培训中';
  title: string = '培训中';
  trainStatus: string = '培训中';
  classesList: TrainClassDto[] = [];

  deleteTrain(id: string) {
    console.log('%c [  ]-62', 'font-size:13px; background:pink; color:#bf2c9f;', 1);
    this.classesList = this.classesList.filter(e => e.id != id);
  }

  stateSwtich(name: string) {
    this.trainStatus = name;
    if (name === '未生成培训记录') {
      this.trainStatus = '已结束';
    }
    this.title = name;
    this.classesList = [];
    this.getClasses(name);
  }

  async getClasses(statu: string = '培训中') {
    this.loading = true;
    try {
      let statuQuery = ClassState.培训中;
      switch (statu) {
        case '培训中':
          statuQuery = ClassState.培训中;
          break;
        case '未报道':
          statuQuery = ClassState.未报道;
          break;
        case '已结束':
        case '未生成培训记录':
          statuQuery = ClassState.已结束;
          break;
      }
      const { data } = await api.ClassSolution.findClassSolutions_GET({
        state: statuQuery,
      });
      let classesList = data!.items!;
      if (statuQuery === ClassState.培训中) {
        const res1 = await api.TrainRecords.checkIsSignin_POST({ ids: classesList.map(e => e.id) });
        if (res1?.data) {
          res1.data.forEach((e: any) => {
            const item = classesList.find(v => v.id == e) as any;
            if (item) {
              this.$set(item, 'isSignin', true);
            }
          });
        }
      }
      if (statuQuery === ClassState.已结束) {
        const res = await api.TrainRecords.checkIsHaveTrainRecord_POST({ ids: classesList.map(e => e.id) });
        const res1 = await api.TrainRecords.checkIsSignin_POST({ ids: classesList.map(e => e.id) });
        console.log('%c [ res1 ]-95', 'font-size:13px; background:pink; color:#bf2c9f;', res1);
        if (res?.data) {
          res.data.forEach((e: any) => {
            const item = classesList.find(v => v.id == e) as any;
            if (item) {
              this.$set(item, 'isRecord', true);
            }
          });
        }
        if (res1?.data) {
          res1.data.forEach((e: any) => {
            const item = classesList.find(v => v.id == e) as any;
            if (item) {
              this.$set(item, 'isSignin', true);
            }
          });
        }
      }
      if (statu == '未生成培训记录') {
        this.classesList = classesList.filter((e: any) => !e.isRecord);
      } else if (statu === '培训中') {
        const res1 = await api.TrainRecords.checkIsSignin_POST({ ids: classesList.map(e => e.id) });
        if (res1?.data) {
          classesList.forEach((e: any) => {
            const item = res1.data.includes(e.id);
            if (item) {
              this.classesList.push(e);
            }
          });
        }
      } else if (statu == '未报道') {
        const res = await api.TrainRecords.checkIsSignin_POST({ ids: classesList.map(e => e.id) });
        if (res?.data) {
          classesList.forEach((e: any) => {
            const item = res.data.includes(e.id);
            if (!item) {
              this.classesList.push(e);
            }
          });
        }
      } else {
        this.classesList = classesList;
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }

  mounted() {
    this.getClasses();
  }
}
